import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { palette } from 'styled-theme';
import { withRouter } from 'react-router-dom';

const StyledButton = styled.button`
  cursor: ${ifProp('disabled', 'auto', 'pointer')};
  outline: 0;
  border: 0;
  padding: 0.25rem 2rem;
  background: ${ifProp('disabled', palette('grayscale', 4), ({ color }) => palette(color, 0))};
  border-radius: 0.5rem;
  transition: ease 0.3s;
  :hover {
    background: ${ifProp('disabled', palette('grayscale', 4), ({ color }) => palette(color, 1))};
  }
  :active {
    background: ${ifProp('disabled', palette('grayscale', 4), ({ color }) => palette(color, 2))};
  }
  ${ifProp('fullWidth', css`
    display: block;
    width: 100%;
  `)}
`;

const Button = ({ onClick, to, disabled, color, fullWidth, ...props }) => {
  const { history } = props;
  const newOnClick = (e) => {
    if (to) {
      history.push(to);
    }
    return onClick(e);
  }
  return (
    <StyledButton
      onClick={newOnClick}
      disabled={disabled}
      color={color}
      fullWidth={fullWidth}
      {...props}
    />
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  to: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
};

Button.defaultProps = {
  onClick: () => {},
  to: null,
  disabled: false,
  color: 'primary',
  fullWidth: false,
};

export default withRouter(Button);
